import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useDeleteEditorsPick = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: mutateAsyncDeleteEditorsPick } = useMutation('deleteEditorsPick', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['editors-pick'] });
      toast.success(res.message);
      await revalidate(['editorRecommendedStores']);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsyncDeleteEditorsPick };
};

export default useDeleteEditorsPick;
